import styles from "./FakePostcodeChecker.module.scss";
import Delivery24PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Delivery24PxOutlined";
import Input from "@JohnLewisPartnership/jl-design-system/dist/elements/input/Input";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { useState } from "react";
import cookies from "js-cookie";
import { dispatchMonetateQEvent } from "../../utils/monetate/monetateQ";
import { usePrivacyFunctionalAccepted } from "../../hooks/usePrivacyFunctionalAccepted/usePrivacyFunctionalAccepted";

type Props = {
  domain: string;
};
export const FakePostcodeCheckerUI = ({ domain }: Props) => {
  const [showMessage, setShowMessage] = useState(false);
  const hasAcceptedPrivacyTerms = usePrivacyFunctionalAccepted();

  const onDoorClick = () => {
    setShowMessage(true);
    if (hasAcceptedPrivacyTerms) {
      cookies.set("postcodepainteddoor", "true", {
        expires: 15, //days
        domain,
      });
    }
    dispatchMonetateQEvent("painted_door_postcode_click");
  };
  return (
    <div
      data-testid="product:postcode-checker"
      className={styles.postcodeCheckerContainer}
      aria-hidden="true"
      tabIndex={-1}
    >
      {!showMessage && (
        <div data-testid="product:postcode-checker:form" onClick={onDoorClick}>
          <h2 className={styles.title}>
            {" "}
            <Delivery24PxOutlinedIcon />
            Delivery and collection options
          </h2>
          <div className={styles.checker}>
            <Input
              placeholder="Enter postcode"
              id="postcode-checker"
              name="postcode-checker"
              value=""
              aria-hidden="true"
              tabIndex={-1}
              onFocus={onDoorClick}
            />
            <SecondaryButton type="submit" aria-hidden="true" tabIndex={-1}>
              Check
            </SecondaryButton>
          </div>
        </div>
      )}
      {showMessage && (
        <div
          data-testid="product:postcode-checker:message"
          className={styles.message}
        >
          <h2 className={styles.title}> Thanks for your interest</h2>
          <span className={styles.infoText}>
            This is a new feature we&apos;re still working on and isn&apos;t
            quite ready yet. By showing your interest you&apos;ve helped us
            understand if our customers would find it useful.
          </span>
        </div>
      )}
    </div>
  );
};
